module.exports = __webpack_public_path__ + "static/media/buildings.52a87d68.png";